import React from 'react';
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { MoreVert, } from '@mui/icons-material';

export type MenuItemType = {
  text: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

type Props = {
  items: MenuItemType[];
};

const DropDownMenu: React.FC<Props> = ({ items, }) => {
  const [anchorEl, setAnchorEl,] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Tooltip title="Actions">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right',
          vertical: 'top', }}
        anchorOrigin={{ horizontal: 'right',
          vertical: 'bottom', }}
      >
        {items.map((item, index) => (
          <MenuItem key={index} onClick={item.onClick}>
            {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>} {item.text}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
};

export { DropDownMenu, };
